<template>
  <no-auth-layout>
    <div class="check-inbox-page center-align">
      <img src="../assets/send_email.png" alt="email wysłany">
      <h2 class="card-title">Sprawdź skrzynkę</h2>
      <p class="card-subtitle">
        Kliknij w link aktywacyjny,<br/>
         aby w pełni korzystać ze swojego konta.
      </p>

      <router-link :to="{ name: 'login' }">
        <button class="btn-large z-depth-0">
          <i class="mfind-icon-back left"></i>
          Wróć do logowania
        </button>
      </router-link>

      <br>
      <div class="card-footer">
        Jeśli nadal potrzebujesz pomocy,<br/>
        wyślij email na <a href="mailto:partnerzy@punkta.pl"> partnerzy@punkta.pl </a>
      </div>
    </div>
  </no-auth-layout>
</template>

<script>
import NoAuthLayout from '@/layouts/noAuthLayout'
export default {
  name: 'passReset',
  components: { NoAuthLayout },
  beforeCreate () {
    if (this.$store.getters.isLoggedIn) {
      this.$router.push({ name: 'dashboard' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// checkInbox.vue?c0be8234